import { createReducer } from '@reduxjs/toolkit';

import { AcadlyPage } from '../db/shared/types';
import { setPageStatus } from './actions';
import { PageStatus } from './types';

type Pages = {
  [key in AcadlyPage]?: PageStatus | undefined;
};

const initialState: Pages = {};

const pagesReducer = createReducer(initialState, (builder) => {
  builder.addCase(setPageStatus, (state, action) => {
    const { page, status } = action.payload;
    state[page] = status;
  });
});

export default pagesReducer;
